import React from "react";
import { useReads } from "../hooks/useReads";
import { getScnDex } from "../web3/contracts";
import { fmtUsdt, shortAddress } from "../utils/format";
import { ACTIVE_CONTRACTS } from "../config/app.config";
import StatGrid from "../components/admin/StatGrid";
import AddressBar from "../components/admin/AddressBar";

export default function ScnDexAdmin() {
  const { data, reload } = useReads(async (provider) => {
    const d = getScnDex(provider);
    const [scn, price] = await Promise.all([d.scn(), d.currentPrice()]);
    return { scn, price };
  });

  return (
    <div className="stack">
      <AddressBar label="SCN DEX Contract" address={ACTIVE_CONTRACTS.scnDex} />
      <StatGrid
        title="SCN DEX — Overview" icon="spark" accent="violet" onRefresh={reload}
        rows={data ? [
          { label: "DEX Address", value: shortAddress(ACTIVE_CONTRACTS.scnDex), mono: true },
          { label: "Linked SCN", value: shortAddress(data.scn), mono: true },
          { label: "Current Price", value: `$${fmtUsdt(data.price, 4)}` },
        ] : []}
      />

      <div className="card">
        <div className="row" style={{ gap: 10 }}>
          <span className="dex-note-ico" style={{ flex: "0 0 auto", width: 34, height: 34, borderRadius: 10, display: "grid", placeItems: "center", color: "#0a0712", background: "var(--grad-accent)" }}>ℹ</span>
          <p className="muted" style={{ margin: 0, fontSize: 13, lineHeight: 1.55 }}>
            The SCN DEX is a thin, immutable sell router with no owner or admin functions.
            All pricing, liquidity and pause control live on the <strong>SCN Token</strong> contract —
            manage those from the SCN Token tab.
          </p>
        </div>
      </div>
    </div>
  );
}
